import { sectionNames } from '@common/intl'
import PageHeader from '@components/PageHeader'
import type { Permission, UserFragment } from '@gql'
import type { IconProps } from '@mui/material'
import { hasAnyPermissions } from '@sections/auth/access'
import Container from '@ui/Container'
import { NavigationCard } from '@ui/NavigationCard'
import SectionLabel from '@ui/SectionLabel'
import type React from 'react'
import { useIntl } from 'react-intl'

import * as S from './styles'

export interface MenuItem {
  description: string
  icon: React.ReactElement<IconProps>
  permissions: Permission[]
  title: string
  url: string
  testId: string
}

export interface MenuSection {
  label: string
  menuItems: MenuItem[]
}

export interface ConfigurationPageProps {
  menu: MenuSection[]
  user: UserFragment
}

export const ConfigurationPage: React.FC<ConfigurationPageProps> = ({ menu: menus, user }) => {
  const intl = useIntl()
  return (
    <Container>
      <PageHeader title={intl.formatMessage(sectionNames.configuration)} />
      {menus
        .filter((menu) =>
          menu.menuItems.some((menuItem) => hasAnyPermissions(menuItem.permissions, user)),
        )
        .map((menu, menuIndex) => (
          <S.ConfigurationCategory key={menuIndex}>
            <S.ConfigurationLabel>
              <SectionLabel>{menu.label}</SectionLabel>
            </S.ConfigurationLabel>
            <S.ConfigurationItem>
              {menu.menuItems
                .filter((menuItem) => hasAnyPermissions(menuItem.permissions, user))
                .map((item, itemIndex) => (
                  <S.ItemLink to={item.url} key={itemIndex}>
                    <NavigationCard
                      icon={item.icon}
                      title={item.title}
                      description={item.description}
                      data-test-id={
                        item.testId + '-settings-subsection-' + item.title.toLowerCase()
                      }
                    />
                  </S.ItemLink>
                ))}
            </S.ConfigurationItem>
          </S.ConfigurationCategory>
        ))}
    </Container>
  )
}

ConfigurationPage.displayName = 'ConfigurationPage'
export default ConfigurationPage
